import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router';

import { PROJECT_TYPES } from '../../../../constants';
import { setCollectDataMessages } from '../../../../redux/scout/scoutReducer';
import MessageFilters from '../../../../scout-new/components/message-filters/MessageFilters';
import {
  createMessageConsumer,
  exportMessagesConsumer,
  resetSessionConsumer,
} from '../../../../redux/consumer/scout/consumerScoutActions';

function ConsumerMessagesFilters() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { projectName } = useParams();

  const messagesContent = useSelector((state) => state.scout.messagesContent);

  const handleCollectResponseData = () => {
    dispatch(setCollectDataMessages(messagesContent));
    navigate(`/${PROJECT_TYPES.SCOUTV2.toLocaleLowerCase()}/collect-data/${projectName}`);
  };

  return (
    <MessageFilters
      onExportMessages={exportMessagesConsumer}
      onCreateMessage={createMessageConsumer}
      onCollectResponseData={handleCollectResponseData}
      onResetSession={resetSessionConsumer}
    />
  );
}

export default ConsumerMessagesFilters;
